import { __rest, __assign } from '../../_virtual/_tslib.js';
import React, { useRef, useEffect } from 'react';
import classnames from 'classnames';
import ScrollLock from 'react-scrolllock';
import styles from './styles.css.js';
import clientOnly from '../../hocs/clientOnly.js';
import CloseIcon from './close.svg.js';

var FlyoutHeader = function FlyoutHeader(_a) {
  var title = _a.title,
      className = _a.className,
      onClose = _a.onClose,
      rest = __rest(_a, ["title", "className", "onClose"]);

  return React.createElement("div", __assign({
    className: classnames(styles.header, className)
  }, rest), React.createElement("span", null, title), React.createElement(CloseIcon, {
    className: styles.closeIcon,
    onClick: onClose
  }));
};
var FlyoutContent = function FlyoutContent(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  return React.createElement("div", __assign({
    className: classnames(styles.content, className)
  }, rest));
};

var Flyout = function Flyout(_a) {
  var _b, _c;

  var isOpen = _a.isOpen,
      _d = _a.from,
      from = _d === void 0 ? 'right' : _d,
      width = _a.width,
      onClose = _a.onClose,
      overlayClassName = _a.overlayClassName,
      flyoutClassName = _a.flyoutClassName,
      children = _a.children,
      rest = __rest(_a, ["isOpen", "from", "width", "onClose", "overlayClassName", "flyoutClassName", "children"]);

  var scrollableContainerRef = useRef(null);
  useEffect(function () {
    var _a, _b;
    /**
     *  Scroll back to the top after closing the flyout
     *
     *  If the first child of the ScrollLock has a ref attribute, it will be overriden by ScrollLock's manipulation
     *    of it's direct child. If we add another div inbetween the ScrollLock and scrollable container, scrolling
     *    doesn't work at all on iOS. With this solution, we find the scrollable container via a data attribute and a
     *    ref from parent ABOVE the ScrollLock. This reaches in and prevents the ref collision.
     */


    !isOpen && ((_b = (_a = scrollableContainerRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('[data-name="scrollable-container"]')) === null || _b === void 0 ? void 0 : _b.scrollTo({
      top: 0
    }));
  }, [isOpen]);
  return React.createElement("div", __assign({
    className: classnames(styles.overlay, overlayClassName, (_b = {}, _b[styles.open] = isOpen, _b)),
    onClick: onClose,
    ref: scrollableContainerRef
  }, rest), React.createElement(ScrollLock, {
    isActive: isOpen
  }, React.createElement("div", {
    "data-name": "scrollable-container",
    className: classnames(styles.flyout, (_c = {}, _c[styles.left] = from === 'left', _c[styles.right] = from === 'right', _c[styles.xsmallWidth] = width === 'xsmall', _c[styles.smallWidth] = width === 'small', _c[styles.mediumWidth] = width === 'medium', _c[styles.largeWidth] = width === 'large', _c[styles.xlargeWidth] = width === 'xlarge', _c), flyoutClassName),
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, children)));
};

var index = clientOnly(Flyout);

export default index;
export { FlyoutContent, FlyoutHeader };
//# sourceMappingURL=index.js.map
